interface AudioFiles {
  intro_envelope_one_easy: string;
  intro_envelope_one_medium: string;
  intro_envelope_one_hard: string;
  how_to_play: string;
  intro_envelope_two?: string;
  stages_complete: string;
}

interface BatchConfig {
  displayName: string;
  stagesFile: string;
  helpDataFile: string; // Help data JSON file, defaults to DEFAULTS.helpDataFile
  policeServerEpisode: string; // e.g., "004_batch2", defaults to DEFAULTS.policeServerEpisode
  policeServerUsername: string; // Username for police server access, defaults to DEFAULTS.policeServerUsername
  audios: Partial<AudioFiles>; // Override specific audio files
  hasMultipleEnvelopes?: boolean; // Indicates if batch has envelope 2
}

interface AppConfigType {
  SHOW_BATCH_SELECTION: boolean;
  DEFAULT_BATCH: string;
  PRESELECTED_BATCH: string;
  DEFAULTS: {
    stagesFile: string;
    helpDataFile: string;
    policeServerEpisode: string;
    policeServerUsername: string;
    audios: AudioFiles;
  };
  BATCHES: {
    [key: string]: BatchConfig;
  };
}

export const AppConfig: AppConfigType = {
  SHOW_BATCH_SELECTION: false, // set to true when multiple batches exist
  DEFAULT_BATCH: "default",
  PRESELECTED_BATCH: "default",
  DEFAULTS: {
    stagesFile: "stages_ks04_v1.json",
    helpDataFile: "help-data.json",
    policeServerEpisode: "004",
    policeServerUsername: "HAUPTMEISTER",
    audios: {
      intro_envelope_one_easy: "/audios/intro_envelope_one_easy.mp3",
      intro_envelope_one_medium: "/audios/intro_envelope_one_medium.mp3",
      intro_envelope_one_hard: "/audios/intro_envelope_one_hard.mp3",
      how_to_play: "/audios/how_to_play.mp3",
      intro_envelope_two: "/audios/intro_envelope_two.mp3",
      stages_complete: "/audios/stages_complete.mp3",
    },
  },
  BATCHES: {
    default: {
      displayName: "Auflage 1",
      stagesFile: "stages_ks04_v1.json",
      helpDataFile: "help-data.json", // Explicit: uses default help data
      policeServerEpisode: "004", // Explicit: uses default episode
      policeServerUsername: "HAUPTMEISTER", // Explicit: uses default username
      hasMultipleEnvelopes: true,
      audios: {
        intro_envelope_one_easy: "/audios/intro_envelope_one_easy.mp3",
        intro_envelope_one_medium: "/audios/intro_envelope_one_medium.mp3",
        intro_envelope_one_hard: "/audios/intro_envelope_one_hard.mp3",
        how_to_play: "/audios/how_to_play.mp3",
        intro_envelope_two: "/audios/intro_envelope_two.mp3",
        stages_complete: "/audios/stages_complete.mp3",
      },
    },
    // Add future batches here:
    // batch_v2: {
    //   displayName: "Auflage 2",
    //   stagesFile: "stages_ks04_v2.json",
    //   helpDataFile: "help-data-v2.json",
    //   policeServerEpisode: "004_batch2",
    //   audios: {
    //     intro_envelope_one_easy: "/audios/batch2/intro_envelope_one_easy.mp3",
    //   },
    // },
  },
};

